// Defaults shared by the three quote forms (RC Pro, PGMA, PGM).
//
// These live in one module because the three forms had drifted: PGMA
// defaulted the coverage inception to today while RC Pro and PGM defaulted
// it to today + 30 days. Same field, same tenant, three products, two
// answers.
//
// The +30 default was also actively misleading. Quote validity defaults to
// 30 days too (DEFAULT_QUOTE_VALIDITY_DAYS in backend productCatalog.js),
// so every quote created from the form came out with its coverage inception
// on exactly the same calendar day as its acceptance deadline. Nothing
// linked the two values — they were independent 30-day windows that always
// landed on the same date — but on screen and on the generated document the
// contract looked like it started the day the quote died, and the offer →
// policy conversion then pre-filled that same date as the policy inception.
// QA reported it as "valid from appears to be the same as quote expiry".
//
// Defaulting to today removes the collision and matches what PGMA already
// shipped. It is only a DEFAULT: the inception is a date field the user sets
// per quote, and nothing here constrains it.

/** Today, as the yyyy-mm-dd string an <input type="date"> expects. */
export function defaultEffectiveDate() {
  return new Date().toISOString().slice(0, 10);
}

/**
 * The last day of a one-year period starting on `startIso` (yyyy-mm-dd).
 *
 * An annual motor policy incepting 01.10.2026 runs to 30.09.2027, not to
 * 01.10.2027 — the seeded Gulf Union book states its periods exactly that
 * way. Returns '' for an unparseable start so the caller stores nothing
 * rather than an invented date.
 */
export function annualPeriodEnd(startIso) {
  if (!startIso) return '';
  const d = new Date(`${startIso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return '';
  const end = new Date(d);
  end.setUTCFullYear(end.getUTCFullYear() + 1);
  end.setUTCDate(end.getUTCDate() - 1);
  return end.toISOString().slice(0, 10);
}
